import React from 'react'
import { Checkbox } from "antd";
import Utils from "Utils";

export function AntCheckbox({
    fieldName,
    value,
    setFieldValue,
    isRequired = false,
    label = null,
    options = {} }) {
    return (
        <div className="custom-field flex flex-column">
            <div className={`label ${isRequired && 'required'}`}>{label || Utils.convertSnakeCaseToSpace(fieldName)}</div>
            <Checkbox name={fieldName} checked={value} onChange={(e) => setFieldValue(fieldName, e.target.checked)} {...options} />
        </div>
    )
}
